import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useState, useEffect } from "react";

function LookupErrorTable({ colnames, unmappedVals }) {
  const [tableRows, setTableRows] = useState([]);
  const [tableHeader, setTableHeader] = useState([]);

  useEffect(() => {
    const lookupErrors = [];

    unmappedVals.forEach((val) => {
      // if its an empty string, replace it by <blank>
      // because thats how blank value looks while mapping lookup for templates
      val = val.map((item) => (item === "" ? "<blank>" : item));
      lookupErrors.push({
        unmapped: val,
        issue: "No mapped output",
      });
    });

    setTableRows(lookupErrors);
    setTableHeader(colnames);
  }, [colnames, unmappedVals]);

  return (
    <>
      {tableRows.length > 0 && (
        <TableContainer>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>{tableHeader}</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tableRows.map((row) => (
                <TableRow key={row.unmapped}>
                  <TableCell component="th" scope="row" sx={{ width: "50%" }}>
                    {row.unmapped}
                  </TableCell>
                  <TableCell>{row.issue}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </>
  );
}

export default LookupErrorTable;
